export const environment = {
  production: false,
  //authApiBase: 'http://localhost:8082/api/auth',
  //dataApiBase: 'http://localhost:8083/api/opportunities',
  //authApiBase: 'http://74.234.38.91/api/auth',
  //dataApiBase: 'http://74.234.38.91/api/data',
  authApiBase: '/api/auth',
  dataApiBase: '/api/data',
  builderApiKey: 'fd4814467bb54a6da123213a976892e2'
};
